import React from "react";
import { withStyles, createStyles } from "@material-ui/core/styles";
import Tab from "@material-ui/core/Tab";
import { amxPalette } from "../ThemeProvider";

export const AmxTab = withStyles((theme) =>
  createStyles({
    root: {
      textTransform: "none",
      color: `${amxPalette.grey.main} !important`,
      fontWeight: theme.typography.fontWeightRegular,
      fontSize: theme.typography.pxToRem(15),
      opacity: 0.4,
      textTransform: "uppercase",
      transition: "opacity 0.25s ease",
      "&:focus, &:hover": {
        opacity: 1,
      },
    },
    selected: {
      opacity: 1,
    },
  })
)((props) => <Tab {...props} />);
